import React, { useEffect, useState } from "react";
import { useSpring, animated } from "@react-spring/web";
import { i18n } from "../i18n";
import { useUserSettings } from "../user";
import sunset from "./../pics/cont.jpg";
import "./../Music.css";
import { isMobile } from "react-device-detect";

export const Music = () => {
  const [settings] = useUserSettings();
  const { language } = settings;
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      setRefreshKey((prevKey) => prevKey + 1);
    }, 500);
  }, []);

  const fadeIn = useSpring({
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 0.9, transform: "translateY(0px)" },
    config: { duration: 1000 },
  });

  const fadeIn2 = useSpring({
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0px)" },
    config: { duration: 1000 },
  });

  const MobileView = () => {
    return (
      <div className="white2_m">
        <animated.div style={fadeIn2} className="music-content_m">
          <div className="mtext">
            <h6 className="music_title_m">
              {i18n({ index: "dance", language })}
            </h6>
            <h6 className="music_love">WE ♥︎ MUSIC</h6>
            <p className="music_text2_m">
              {i18n({ index: "listen", language })}
            </p>
            <div className="music_text_m">
              <button className="music_button">
                <a
                  className="music_href"
                  href="https://open.spotify.com/user/olikuhn555/playlists"
                >
                  Spotify
                </a>
              </button>
              <button className="music_button">
                <a
                  className="music_href"
                  href="https://soundcloud.com/olitademarmusic?ref=clipboard&p=i&c=1&si=DA10868489C04CDD9A5CB65C3BDEE359&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing"
                >
                  SoundCloud
                </a>
              </button>
            </div>
          </div>
        </animated.div>
        <animated.img
          // ref={refImg}
          style={fadeIn}
          src={sunset}
          alt=""
          className="music_pic_m"
        ></animated.img>
        <animated.div style={fadeIn2} className="music-content_m">
          <div className="music-players">
            <iframe
              key={refreshKey}
              title="Spotify Playlist"
              src="https://open.spotify.com/embed/playlist/4f2JajRYuSk4cpTBVINKKV"
              // width="80%"
              height="500"
              frameBorder="0"
              allow="encrypted-media"
              view="coverart"
            ></iframe>
          </div>
        </animated.div>
      </div>
    );
  };

  const DesktopView = () => {
    return (
      <>
        <div className="white2">
          <animated.img
            // ref={refImg}
            style={fadeIn}
            src={sunset}
            alt=""
            className="music_pic"
          ></animated.img>
          <animated.div style={fadeIn2} className="music-content">
            <div className="music-players">
              <iframe
                key={refreshKey}
                title="Spotify Playlist"
                src="https://open.spotify.com/embed/playlist/4f2JajRYuSk4cpTBVINKKV"
                // width="80%"
                height="500"
                frameBorder="0"
                allow="encrypted-media"
                view="coverart"
              ></iframe>
            </div>
          </animated.div>

          <animated.div style={fadeIn2} className="music-content">
            <div className="mtext">
              <h6 className="music_title">
                {i18n({ index: "dance", language })}
              </h6>
              <h6 className="love_music">WE ♥︎ MUSIC</h6>
              <p className="music_text_left">
                {i18n({ index: "listen", language })}
              </p>
              <div className="music_text">
                <button className="music_button">
                  <a
                    className="music_href"
                    href="https://open.spotify.com/user/olikuhn555/playlists"
                  >
                    Spotify
                  </a>
                </button>
                <button className="music_button">
                  <a
                    className="music_href"
                    href="https://soundcloud.com/olitademarmusic?ref=clipboard&p=i&c=1&si=DA10868489C04CDD9A5CB65C3BDEE359&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing"
                  >
                    SoundCloud
                  </a>
                </button>
              </div>
            </div>
          </animated.div>
        </div>
      </>
    );
  };

  return <div>{isMobile ? <MobileView /> : <DesktopView />}</div>;
};
